<template>
    <div id="tryout-form">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Ambis Test',
                    exact: true,
                },
                {
                    text: 'Skala',
                    exact: true,
                },
                { text: !$route.query.id ? 'Tambah Skala' : 'Ubah Skala' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <div class="d-flex">
            <h3 class="header-text font-weight-bold">
                {{ !$route.query.id ? "Tambah Skala" : "Ubah Skala" }}
            </h3>
            <v-spacer />

            <div class="mt-5" v-if="step === 3">
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            :class="btn_class_selected"
                            depressed
                            v-bind="attrs"
                            v-on="on"
                            dark
                            class="px-3"
                        >
                            {{ scale_status }}
                            <v-icon class="ml-2">mdi-menu-down</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item
                            v-for="(item, index) in dropdown"
                            :key="index"
                            @click="confirmUpdateScaleStatus(item)"
                        >
                            <v-list-item-title>{{
                                item.title
                            }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>
        </div>

        <v-card>
            <v-stepper v-model="step" flat class="pa-0" color="blew">
                <v-card-text>
                    <v-stepper-header flat style="box-shadow: none">
                        <v-stepper-step :complete="step > 1" step="1">
                            Skala
                        </v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step :complete="step > 2" step="2">
                            Pertanyaan
                        </v-stepper-step>
                        <v-divider></v-divider>

                        <v-stepper-step step="3"> Interpretasi </v-stepper-step>
                    </v-stepper-header>
                </v-card-text>

                <v-stepper-items>
                    <v-stepper-content step="1">
                        <app-skalaform
                            v-if="step === 1"
                            :data="data"
                            v-on:completed="goToNextStep($event)"
                            v-on:uncompleted="goToPrevStep($event)"
                        />
                    </v-stepper-content>

                    <v-stepper-content step="2">
                        <app-questionform
                            v-if="step === 2"
                            :data="data"
                            v-on:completed="goToNextStep($event)"
                            v-on:uncompleted="goToPrevStep($event)"
                        />
                    </v-stepper-content>

                    <v-stepper-content step="3">
                        <app-interpretationform
                            v-if="step === 3"
                            :data="data"
                            v-on:completed="goToNextStep($event)"
                            v-on:uncompleted="goToPrevStep($event)"
                        ></app-interpretationform>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </v-card>

        <v-dialog v-model="confirmDialog" persistent max-width="490px">
            <v-card class="py-2">
                <v-card-title style="word-break: break-word !important">
                    {{ publish_title_confirm }}
                </v-card-title>
                <v-card-text> {{ publish_subtitle_confirm }} </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="darkFade" text @click="confirmDialog = false">
                        Batal
                    </v-btn>
                    <v-btn
                        color="blew"
                        text
                        dark
                        depressed
                        :loading="isLoadingForm"
                        @click="updateScaleStatus()"
                    >
                        {{ btn_confirm_title }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import SkalaForm from "@/modules/ambis_test/components/SkalaForm";
import QuestionForm from "@/modules/ambis_test/components/QuestionForm";
import InterpretationForm from "@/modules/ambis_test/components/InterpretationForm";
import ambis_test from "../services/ambis_test";

export default {
    components: {
        "app-skalaform": SkalaForm,
        "app-questionform": QuestionForm,
        "app-interpretationform": InterpretationForm,
    },

    data: function () {
        return {
            step: 1,
            isLoading: false,
            isLoadingForm: false,
            selectedValBtn: null,
            confirmDialog: false,
            stepName: ["Skala", "Pertanyaan", "Interpretasi"],
            data: {},
            dropdown: [
                {
                    id: "draft",
                    title: "Draft",
                    btn_class: "draft-btn",
                    title_confirm: 'Ubah status "Draft"?',
                    subtitle_confirm:
                        "Skala tidak akan muncul di aplikasi Skolla.",
                },
                {
                    id: "soon",
                    title: "Coming Soon",
                    btn_class: "soon-btn",
                    title_confirm: 'Ubah status "Coming Soon?"',
                    subtitle_confirm:
                        "Skala akan muncul di aplikasi Skolla dengan status coming soon.",
                },
                {
                    id: "publish",
                    title: "Publish",
                    btn_class: "publish-btn",
                    title_confirm: "Publish Skala?",
                    subtitle_confirm: "Skala akan muncul di aplikasi Skolla.",
                },
                {
                    id: "hidden",
                    title: "Hidden",
                    btn_class: "draft-btn",
                    title_confirm: 'Ubah status "Hidden"?',
                    subtitle_confirm:
                        "Skala tidak akan muncul di aplikasi Skolla.",
                },
            ],
            scale_status: "Draft",
            btn_class_selected: "draft-btn",
            publish_title_confirm: "",
            publish_subtitle_confirm: "",
            btn_confirm_title: "",
        };
    },

    methods: {
        // to change tab
        goToNextStep: function (val) {
            this.data = val;
            // alert(JSON.stringify(val));

            if (this.step === 2) {
                const status = this.data.status;
                this.btn_class_selected = this.dropdown.find(
                    (e) => e.id === status
                ).btn_class;

                this.scale_status = this.dropdown.find(
                    (e) => e.id === status
                ).title;
            }

            if (this.step === 3) {
                return this.$router.push({ path: "/detail-skala" });
            }

            this.step++;

            this.setUrlTab();
        },

        goToPrevStep: function (val) {
            this.data = val;
            this.step--;

            this.setUrlTab();
        },

        setUrlTab() {
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    tab: this.step,
                    scale_id: this.data.id || this.$route.query.scale_id,
                },
            });
        },

        confirmUpdateScaleStatus(val) {
            this.selectedValBtn = val;
            this.publish_title_confirm = val.title_confirm;
            this.publish_subtitle_confirm = val.subtitle_confirm;
            this.btn_confirm_title = val.title;

            this.confirmDialog = true;
        },

        updateScaleStatus() {
            var context = this;
            const id = context.$route.query.scale_id || context.$attrs.data.id;

            context.isLoadingForm = true;

            const data = {
                id: id,
                status: context.selectedValBtn.id,
            };

            ambis_test.updateStatusScale(data, function (result) {
                if (result.success) {
                    context.confirmDialog = false;
                    context.isLoadingForm = false;
                    context.scale_status = context.selectedValBtn.title;
                    context.btn_class_selected =
                        context.selectedValBtn.btn_class;

                    context.$store.commit("showAlert", {
                        message: `Status Skala berhasil diubah menjadi ${context.selectedValBtn.title}`,
                        type: "success",
                    });
                } else {
                    context.$store.commit("showAlert", {
                        message: `Gagal Mengubah Skala!`,
                        type: "error",
                    });

                    context.isLoadingForm = false;
                }
            });
        },
    },

    mounted: function () {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

        this.step = parseInt(this.$route.query.tab) || 1;
    },
};
</script>

<style>
.draft-btn {
    background-color: white !important;
    color: #5f6377 !important;
    border: 1.5px solid #e0e0e0 !important;
}

.publish-btn {
    background-color: #27ae60 !important;
    color: #fff !important;
    border: 1.5px solid #27ae60 !important;
}

.soon-btn {
    background-color: #fdf6df !important;
    color: #f39c00 !important;
    border: 1.5px solid #f39c00 !important;
}
</style>



// WEBPACK FOOTER //
// Form.vue?3b034bea